<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">Role Management</h3>
              <router-link :to="{ path: 'role/create' }" class="float-right mt-0">
                <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add Role</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title :class="$vuetify.breakpoint.mdAndUp ? 'col-4 float-right' : 'col-12'">
                <v-text-field
                  class="search-text-field"
                  v-model="search"
                  append-icon="search"
                  label="Search by role"
                  single-line
                  hide-details
                  v-debounce:1s="searchFilter"
                  :debounce-events="['click', 'keydown']"
                ></v-text-field>
              </v-card-title>
              <v-data-table
                class="float-left"
                style="width:100%"
                :headers="headers"
                :items="roles"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:[`item.active`]="{ item }">
                  <v-chip
                    label
                    :color="getColor(item)"
                    dark
                  >{{ item.active? 'Active' : 'Inactive' }}</v-chip>

                  <v-chip
                    label
                    class="mx-2"
                    v-if="item.isDelete"
                    :color="getColor(item)"
                    dark
                  >{{ item.isDelete? 'Deleted' : 'no' }}</v-chip>
                </template>
                <template v-slot:[`item.show`]="{ item }">{{ item.show? 'Yes' : 'No' }}</template>
                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'role/' + item._id }">
                    <v-tooltip bottom :color="$vuetify.theme.themes.light.tooltipColor">
                      <template v-slot:activator="{ on: tooltip, attrs }">
                      <img
                        v-bind="attrs"
                        v-on="{ ...tooltip }"
                        class="mr-2 edit-icon"
                        src="@/assets/images/Edit.svg" />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>
                  <delete-component
                    v-if="userType === 'super'"
                    :id="item._id"
                    module="role/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end pt-2 float-left" style="width:100%">
                <v-pagination circle v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import { RoleService } from "@/services";

export default {
  name: "Roles",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    roles: [],
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    search: "",
    userType: "",
    headers: [
      {
        text: "Role",
        align: "start",
        value: "name",
      },
      { text: "Status", value: "active" },
      { text: "Visible to Doctor?", value: "show" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    defaultItem: {
      name: "",
      active: false,
      show: false,
    },
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.userType = this.$store.state.user.user.userType;
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        search: this.search,
      };
      const roleList = await RoleService.RolesList(params);
      if (roleList.data.data.length > 0) {
        this.pageCount = Math.ceil(
          roleList.data.option[0].count / this.itemsPerPage
        );
        this.roles = roleList.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.roles = [];
      }
    },
    async handleClick(value) {
      this.$router.push("role/" + value._id);
    },
    getColor(object) {
      if (object.active) {
        return "#30E362";
      } else {
        return "#5B5B5B";
      }
    },
    searchFilter() {
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
  },
};
</script>